/* eslint-disable no-case-declarations */
import EventEmitter from 'eventemitter3';
import { ws } from '~/common/js/rx-websocket';
// import Tv from '~/assets/js/tv-new'
import { NORMAL_SUBSCRIBE_MAP } from '~/common/js/workerConfig';
import { useSubscriptionStore } from '~/store/subscription';
// import { useTradeStore } from '~/store/trade';
// import * as Sentry from '@sentry/vue'

// const SENTRY_ENABLE =
//   process.env.NODE_ENV === 'production' && ['testing', 'production'].includes(process.env.domain_env)

export default defineNuxtPlugin((nuxtApp) => {
  const ee = new EventEmitter();
  const subscriptionStore = useSubscriptionStore();
  // const tradeStore = useTradeStore();

  const handleWsMessage = (msg) => {
    let { payload } = msg;
    const { type } = msg;
    if (!ws.ws) {
      ws.connect();
    }
    // console.log('handleWsMessage', type, payload);
    switch (type) {
      // 暂时未用到相关逻辑，临时注释，后续用到逐步放开
      //   case NORMAL_SUBSCRIBE_MAP.TRADE:
      //     // 最新成交数据，对接 K线 和 最新成交面板
      //     // 理论上这个价格是最新的
      //     // 第一步先打平再并排序
      //     const currentSymbolId = +ctx.store.state.trade.symbolInfo.symbolId;
      //     if (payload.symbol === currentSymbolId) {
      //       const firstSubscribe = payload.firstSubscribe === '0';
      //       // 按照时间由晚到早排序
      //       const flattenTradeData = (Array.isArray(payload.data.trades) ? payload.data.trades : []).sort((a, b) => {
      //         if (a.time === b.time) {
      //           return b.sequence - a.sequence;
      //         } else {
      //           return b.time - a.time;
      //         }
      //       });

      //       if (flattenTradeData.length) {
      //         Tv.onUpdateTickData({ ...flattenTradeData[0], symbol: payload.symbol });
      //         tradeStore.updateLatestPrice(flattenTradeData[0]?.price);
      //         // console.log(type, payload);
      //         ee.emit('trade', {
      //           flattenTradeData,
      //           firstSubscribe,
      //         });
      //       }
      //     }

      //     break;
      //   case NORMAL_SUBSCRIBE_MAP.KLINE:
      //     // console.log(type, payload)
      //     Tv.onUpdateKline(payload);
      //     break;
      //   case NORMAL_SUBSCRIBE_MAP.DEPTH:
      //     // console.log(type, payload);
      //     ee.emit('depth', payload);
      //     break;
      //   case NORMAL_SUBSCRIBE_MAP.INNOVATE:
      //     // 实际未用到
      //     // ee.emit('innovate', payload)
      //     break;
      case NORMAL_SUBSCRIBE_MAP.PRICE:
        // 分屏订阅交易对价格，可收到所有订阅币对的价格，不一定是最新

        const priceData = [
          {
            data: payload.data,
            symbolId: payload.symbol,
          },
        ];

        // tradeStore.CHANGE_SYMBOL_INFO(priceData);
        subscriptionStore.UPDATE_PRICE_LIST(priceData);
        break;
      //   case NORMAL_REQUEST_MAP.TICKERS:
      //     if (payload.code === 0) {
      //       tradeStore.updateSymbolTickers(payload.data);
      //     }
      //     ee.emit(NORMAL_REQUEST_MAP.TICKERS, payload);
      //     break;
    }
    payload = null;
  };

  ws.on('postMessage', handleWsMessage);

  return {
    provide: {
      worker: {
        ws,
        ee,
      },
    },
  };
});
